const BoxStyles = {
    baseStyle: {
      _focus: {
        boxShadow: "none",
      },
      icon: {
        color: "primary.dark",
      },
    },
    variants: {
      standardWhite: {
        bg: "white",
        borderRadius: "lg",
        px: [2, null, null, 6, null],
        py: [2, null, null, 4, null],
        transition: "all 0.3s ease-in-out",
        overflow: "hidden",
      },
      squareWhite: {
        bg: "white",
        borderRadius: "1px",
        px: [2, null, null, 6, null],
        py: [2, null, null, 4, null],
        transition: "all 0.3s ease-in-out",
        overflow: "hidden",
        position: "relative",
      },
      greyBox: {
        border: "1px solid",
        borderColor: "greyInput",
        // bg: "white",
        borderRadius: "3px",  
        _placeholder: { color: "lightSearch" }, 
        _hover: {bg: "blueInputHover"},
        fontSize: ["sm"],
      },
    },
    defaultProps: {
      variant: "boxWhite", // Optional: Set a default variant if you want all Boxes to use this by default
    },
  };
  
  export default BoxStyles;
  